import { render, staticRenderFns } from "./EmployeeForms.vue?vue&type=template&id=125d1d75"
import script from "./EmployeeForms.vue?vue&type=script&lang=js"
export * from "./EmployeeForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports